import { loadBeacon4BlendedSeries, clearBeacon4BlendedSeries } from '../reducers/Beacon4KpiDataReducer';
import { loadBeacon4Rag } from '../reducers/Beacon4RagReducer';

const BLENDED_KPI_KEYS = ['avail', 'vssr', 'dssr', 'vdcr', 'ddcr', 'vtraf', 'dtraf'];
const buildParams = (filters) => {
	const p = {
		dateFrom:    filters.dateFrom,
		dateTo:      filters.dateTo,
		aggregation: filters.aggregation,
	};
	if (filters.side)    p.side    = filters.side;
	if (filters.polygon) p.polygon = filters.polygon;
	if (filters.jvid)    p.jvId    = filters.jvid;

	return p;
};

export const loadBeacon4BlendedView = () => async (dispatch, getState) => {
	const filters = getState().beacon4Filters;
	const params  = buildParams(filters);

	dispatch(clearBeacon4BlendedSeries());

	// All 7 KPIs in parallel
	await Promise.all(
		BLENDED_KPI_KEYS.map(kpiKey => dispatch(loadBeacon4BlendedSeries({ kpiKey, ...params })))
	);

	// Load RAG after data
	const { side, polygon } = getState().beacon4Filters;
	if (side) dispatch(loadBeacon4Rag({ side, polygon: polygon || undefined }));
};

export const reloadBeacon4View = () => (dispatch) => {
	dispatch(loadBeacon4BlendedView());
};